<app-profile-messages
    [isWidget]="true"
    [detailHandler]="openDetail"
    [additionalFilter]="additionalFilter()"
></app-profile-messages>
